// src/context/ToastContext.js
import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import Toast from '../components/common/Toast';

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toastData, setToastData] = useState(null);
  const timeoutRef = useRef(null);
  const hoverRef = useRef(false); // pitää kirjaa hoverista

  const startTimer = () => {
    clearTimer(); // nollaa vanha
    timeoutRef.current = setTimeout(() => {
      if (!hoverRef.current) {
        setToastData(null);
        timeoutRef.current = null;
      }
    }, 5000); // 5 sekuntia
  };

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const showToast = ({ product, quantity, action }) => {
    if (!product || typeof quantity === 'undefined') return;

    const message =
      action === 'add' || quantity > 0
        ? `Ostoskorissasi nyt ${quantity} pkt: ${product.name}`
        : `Poistettu ostoskorista: ${product.name}`;

    setToastData({
      message,
      image: product.images?.[0] || '/images/no-image.png',
      price: product.price,
      packSize: product.quantity || 1,
      quantity,
      action,
    });

    startTimer();
  };

  const closeToast = () => {
    clearTimer();
    setToastData(null);
  };

  useEffect(() => {
    return () => clearTimer(); // siivous
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toastData && (
        <Toast
          message={toastData.message}
          image={toastData.image}
          price={toastData.price}
          quantity={toastData.quantity}
          packSize={toastData.packSize}
          action={toastData.action}
          onClose={closeToast}
          onHoverStart={() => {
            hoverRef.current = true;
            clearTimer();
          }}
          onHoverEnd={() => {
            hoverRef.current = false;
            startTimer();
          }}
        />
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
